module.exports = __webpack_public_path__ + "static/media/ArrowLeftIcon.7b8dbd91.svg";